module.exports = __webpack_public_path__ + "ca6a8cfb6d0af8d0156a671f8c1cca7b.woff2";